module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","type":"Type","industry":"Industry","location":"Location","riskProfile":"Risk Profile"},"de":{"name":"Name","type":"Art","industry":"Industrie","location":"Standort","riskProfile":"Risikoprofil"}}')
  delete Component.options._Ctor
}
